import React from 'react';
import Chart from 'react-apexcharts';
import './Earnings.css';

const Earnings = () => {
    const [selectedRange, setSelectedRange] = React.useState('12');

    // Dynamic data based on selected range
    const getChartData = () => {
        const dataMap = {
            '1': {
                categories: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
                data: [25, 30, 20, 35]
            },
            '3': {
                categories: ['Month 1', 'Month 2', 'Month 3'],
                data: [65, 45, 55]
            },
            '6': {
                categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
                data: [45, 52, 38, 24, 33, 26]
            },
            '12': {
                categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                data: [45, 52, 38, 24, 33, 26, 21, 20, 6, 8, 15, 10]
            }
        };
        return dataMap[selectedRange];
    };

    const currentData = getChartData();

    const chartOptions = {
        chart: {
            type: 'bar',
            height: 350,
            toolbar: {
                show: false
            },
            background: 'transparent',
            foreColor: '#333'
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
                borderRadius: 4,
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: currentData.categories,
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            },
            labels: {
                style: {
                    colors: '#666',
                    fontSize: '12px'
                }
            }
        },
        yaxis: {
            min: 0,
            max: 100,
            tickAmount: 5,
            labels: {
                formatter: function (val) {
                    return '$' + val + 'K';
                },
                style: {
                    colors: '#666',
                    fontSize: '12px'
                }
            }
        },
        fill: {
            opacity: 1,
            type: 'gradient',
            gradient: {
                shade: 'light',
                type: 'vertical',
                shadeIntensity: 0.3,
                gradientToColors: ['#667eea'],
                inverseColors: false,
                opacityFrom: 0.8,
                opacityTo: 0.6,
                stops: [0, 100]
            }
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return '$' + val + 'K';
                }
            },
            theme: 'light'
        },
        grid: {
            borderColor: '#e0e6ed',
            strokeDashArray: 5,
            xaxis: {
                lines: {
                    show: false
                }
            },
            yaxis: {
                lines: {
                    show: true
                }
            },
            padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }
        },
        colors: ['#764ba2']
    };
    
    const chartSeries = [{
        name: 'Earnings',
        data: currentData.data
    }];

    const handleRangeChange = (e) => {
        setSelectedRange(e.target.value);
    };

    return (
        <div className="c-card-1 earnings-component">
            <div className="c-card-header-1">
                <div className='d-flex justify-content-between align-items-center w-100'>
                    <div>Earnings</div>
                    <div>
                        <select
                            value={selectedRange}
                            onChange={handleRangeChange}
                            className="form-select"
                            style={{ minWidth: 120 }}
                        >
                            <option value="1">1 Month</option>
                            <option value="3">3 Months</option>
                            <option value="6">6 Months</option>
                            <option value="12">12 Months</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className="earnings-chart">
                <Chart 
                    options={chartOptions} 
                    series={chartSeries} 
                    type="bar" 
                    height={350} 
                />
            </div>
        </div>
    );
};

export default Earnings;
